<div
  #panelRoot
  class="address-suggested-address-panel"
  [class.address-suggested-address-panel--warning]="isUnverifiedWarning()"
  [attr.role]="isUnverifiedWarning() ? null : 'alert'"
  [attr.aria-live]="isUnverifiedWarning() ? null : 'polite'"
  tabindex="-1"
  [attr.aria-labelledby]="labelledById()"
>
  @if (isUnverifiedWarning()) {
    <app-alert-toast severity="warning" live="polite">
      <div class="address-suggested-address-panel__warning-body">
        <p [id]="descriptionId()" class="address-suggested-address-panel__warning-message">
          {{ 'createShipment.suggestedAddress.incorrectAddressSurchargeWarning' | translate }}
        </p>
        <div class="address-suggested-address-panel__actions">
          <puro-button type="button" variant="secondary" (buttonClick)="onKeepEntry()">
            {{ 'createShipment.suggestedAddress.keepEntry' | translate }}
          </puro-button>
        </div>
      </div>
    </app-alert-toast>
  } @else {
    <div class="address-suggested-address-panel__header">
      <div class="address-suggested-address-panel__icon" aria-hidden="true">
        <svg
          class="address-suggested-address-panel__icon-svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="8" fill="currentColor" />
          <path d="M8 4.25V8.75" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" />
          <circle cx="8" cy="11.25" r="0.75" fill="#FFFFFF" />
        </svg>
      </div>

      <puro-typography
        class="address-suggested-address-panel__title"
        variant="body2"
        [id]="titleId()"
      >
        {{ titleKey() | translate }}
      </puro-typography>
    </div>

    <div [id]="descriptionId()" class="address-suggested-address-panel__description">
      <puro-typography
        class="address-suggested-address-panel__lead-in"
        variant="body2"
        color="secondary"
      >
        {{ 'createShipment.suggestedAddress.foundSimilar' | translate }}
      </puro-typography>

      <puro-typography class="address-suggested-address-panel__address" variant="body1">
        {{ displayLine() }}
      </puro-typography>

      <puro-typography
        class="address-suggested-address-panel__review-note"
        variant="body2"
        color="secondary"
      >
        {{ 'createShipment.suggestedAddress.reviewBeforeContinuing' | translate }}
      </puro-typography>
    </div>

    <div class="address-suggested-address-panel__actions">
      <puro-button type="button" variant="primary" (buttonClick)="onUseSuggested()">
        {{ 'createShipment.suggestedAddress.useSuggested' | translate }}
      </puro-button>

      <puro-button type="button" variant="secondary" (buttonClick)="onKeepEntry()">
        {{ 'createShipment.suggestedAddress.keepEntry' | translate }}
      </puro-button>
    </div>
  }
</div>
